import { connect } from 'react-redux'
import NeighborhoodsView from './Neighborhoods.component'
import { loadVisibles } from '../../../../actions/neighborhoodFront'

const mapStateToProps = (state) => {
  return {
    visibleNeighborhoods: state.neighborhoodFront.visible
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadNeighbors: () => {
      dispatch(loadVisibles())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NeighborhoodsView)



// WEBPACK FOOTER //
// ./src/features/PageResidential/components/Neighborhoods/Neighborhoods.container.js